import React from 'react';
import OutrightOddButton from './OutrightOddButton';

// Stacked two-per-row cell: outcome name on top, odds button beneath.
function SelectionRow({ event, market, outcome, betBox }) {
  if (!outcome) return null;

  return (
    <div
      className="d-flex flex-column align-items-stretch"
      style={{
        gap: '0.25rem',
        padding: '0.25rem 0',
        minWidth: 0
      }}>
      <span
        title={outcome.name}
        style={{
          fontSize: '0.8rem',
          lineHeight: 1.2,
          wordBreak: 'break-word',
          textAlign: 'center'
        }}>
        {outcome.name}
      </span>
      <div style={{ width: '100%' }}>
        <OutrightOddButton
          event={event}
          market={market}
          outcome={outcome}
          betBox={betBox}
        />
      </div>
    </div>
  );
}

export default SelectionRow;
